import type { ReportSelectorData } from "@qendo/profile/reports";
import { TrackableType } from "@qendo/trackables";
import { Stack } from "expo-router";
import { FilteredList } from "~/components/layout/FilteredList";
import { ListingItem } from "~/components/layout/ListingItem";
import { Page } from "~/components/layout/Page";
import { SectionHeader } from "~/components/layout/SectionHeader";
import { Only } from "~/components/permission/Only";
import { ShareButton } from "~/components/ShareButton";
import { useReport } from "~/providers/ReportProvider";
import { formatAverage } from "~/util/qendo/reports";

export default function ReportsIndex() {
    const { reports, refreshReports } = useReport();

    return (
        <>
            <Stack.Screen
                options={{
                    headerRight: () => (
                        <ShareButton title="Share Reports" initial={["symptoms", "activities", "journal"]} />
                    ),
                }}
            />
            <Page spacer scrollable={false}>
                <SectionHeader title="Reports" icon="report">
                    Reports of your logged data that you can share with your care team.
                </SectionHeader>
                <Only when={reports.length}>
                    <FilteredList<ReportSelectorData>
                        data={reports}
                        searchWith={(item, term) => item.title.toLowerCase().includes(term.toLowerCase())}
                        searchPlaceholder="Search by name"
                        refreshWith={refreshReports}
                        groups={[
                            { name: "Symptoms", matches: (item) => item.type === TrackableType.symptom },
                            { name: "Activities", matches: (item) => item.type === TrackableType.activity },
                            { name: "Other", matches: (item) => item.type === TrackableType.journal, hideTab: true },
                        ]}
                        renderItem={({ item }) => (
                            <ListingItem
                                title={item.title}
                                hideChevron
                                icon={item.icon}
                                subtitle={`${formatAverage(item.average)} avg ${item.scale_name.toLowerCase()}`}
                                href={{ pathname: `/more/reports/[id]/show`, params: { id: item.id } }}
                                last
                            />
                        )}
                    />
                </Only>
            </Page>
        </>
    );
}
